import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ApiService } from '../../../shared/services/api.service';
import { TextSearchPipe } from '../../../shared/pipes/text-search.pipe';

import { Pcategory, Product, ProductOrder } from '../../../shared/models';

import { environment } from '../../../../environments/environment';

import { faEllipsisH } from '../../../icons';

@Component({
    selector: 'app-products-list',
    templateUrl: './products-list.component.html',
    styleUrls: ['./products-list.component.scss'],
    providers: [TextSearchPipe],
    standalone: false
})
export class ProductsListComponent implements OnInit {
	@Input() pcategory: Pcategory;
  @Input() productNameSearch: string = '';

  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @Output() onProductSelected: EventEmitter<Product> = new EventEmitter();

	products: Product[];

  serverUrl: string = environment.server_url;

  faEllipsisH = faEllipsisH;

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  	this.api.indexAll('products', {
  		q: {
  			pcategory_id: this.pcategory.id,
  			hidden: false,
  			delivery: true
  		}
  	}).subscribe(
  		res => {
        this._setProductsAdditionalData(res.products);
        res.products = Pcategory.orderProducts(this.pcategory, res.products);
  			this.products = res.products;
  		},
  		err => {
  			console.error(err);
  			alert(`Não foi possível encontrar os produtos da categoria ${this.pcategory.name}`);
  		}
  	);
  }

  togglePcategory() {
    this.pcategory.user_hid = !this.pcategory.user_hid;
  }

  selectProduct(product: Product) {
    product.showFullDescription = false;
    this.onProductSelected.emit(product);
  }

  minPizzaPrice(product: Product): string {
    const prices = (product.parsedAdditionalInfo && product.parsedAdditionalInfo.pizza_prices) || [];
    if(!prices.length) {
      return product.price;
    }
    const min = Math.min.apply(null, prices.map(p => Number(p.price)));
    return min.toFixed(2);
  }

  /*showDescription(product, event) {
    if(!product.showFullDescription) {
      event.stopPropagation();
    }
    product.showFullDescription = true;
  }*/

  // product-order object or null, in case user didn't
  // want to add item to cart
  // item is added to cart-service in product-details.component.ts
  onItemAdded(item: ProductOrder) {
    this.onProductSelected.emit(null);
  }

  private _setProductsAdditionalData(products: Product[]) {
    for(let product of products) {
      Product.setAdditionalData(product);
    }
  }
}
